var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[(!_vm.ready)?_c('loader-app'):_c('router-view')],(_vm.loading)?_c('BlockInterface'):_vm._e(),_c('div',{staticClass:"modal-mask"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }